import gql from 'graphql-tag';

export const ASSIGN_POSTS = gql`
  mutation AssignPostsMutation(
    $mentionIds: [String!]!
    $programIds: [Int!]
    $programNames: [String!]
    $communityIds: [Int!]
  ) {
    assignPosts(
      mentionIds: $mentionIds
      programIds: $programIds
      programNames: $programNames
      communityIds: $communityIds
    )
  }
`;
